export const HINDU_D = 2;
export const HINDU_FRONT_W = 22;
export const HINDU_ISO_DX = 15;
export const HINDU_ISO_DY = -10;
export const HINDU_OX = 16;
export const HINDU_OY = 42;
export const HINDU_VIEW_W = 64;
export const HINDU_VIEW_H = 52;
export const HINDU_MOVE_MS = 354;
export const HINDU_GAP_MS = 25;
export const HINDU_MAX_LIFTS = 3;
export const HINDU_DECK = 12;
export const HINDU_PULL = 28;

const ISO_LEN = Math.hypot(HINDU_ISO_DX, HINDU_ISO_DY);
export const HINDU_FRONT_X = -HINDU_ISO_DX / ISO_LEN;
export const HINDU_FRONT_Y = -HINDU_ISO_DY / ISO_LEN;

export const HINDU_TOTAL_MS =
  HINDU_MAX_LIFTS * HINDU_MOVE_MS + (HINDU_MAX_LIFTS - 1) * HINDU_GAP_MS;
